class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
		if (this.detailsContainer) {
			this.detailsContainer.addEventListener('keyup', (event) => {
				if(event.code) {
					event.code.toUpperCase() === 'ESCAPE' && this.close()
				}
			});
		}

		if (this.summaryToggle) {
			this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
			this.summaryToggle.setAttribute('role', 'button');
			this.summaryToggle.setAttribute('aria-expanded', 'false');
		}
    
    const typeButton = this.querySelector('button[type="button"]');
    if (typeButton != null) {
      typeButton.addEventListener('click', this.close.bind(this));
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    this.kgFreezeBody();

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    this.kgUnfreezeBody();
  }

  /* KG: iOS search scroll freeze (round 5) — iOS Safari keeps scrolling the page
     behind the open search once the results panel reaches its end, despite the
     overflow-hidden class, so pin the body in place. Search modals only. */
  kgFreezeBody() {
    if (this.kgScrollY !== undefined) return;
    if (!this.detailsContainer || !this.detailsContainer.querySelector('.search-modal')) return;
    this.kgScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.kgScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  kgUnfreezeBody() {
    if (this.kgScrollY === undefined) return;
    const scrollY = this.kgScrollY;
    this.kgScrollY = undefined;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  disconnectedCallback() {
    this.kgUnfreezeBody();
  }
}

customElements.define('details-modal', DetailsModal);
